module.exports = __webpack_public_path__ + "static/assets/f77ad2c175f84af771b73fa037a12c54.png";